import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import ChatWidget from "./ChatWidget";
import { Toaster } from "sonner";

export default function Layout() {
  return (
    <div className="min-h-screen bg-[#050505] text-[#FFFFF0]">
      <Header />
      <main className="pt-20" data-testid="main-content">
        <Outlet />
      </main>
      <Footer />
      <ChatWidget />
      <Toaster richColors position="top-center" theme="dark" />
    </div>
  );
}
